export function setLockedBadges(state, data) {
  state.lockedBadges = data
}

export function setUnlockedBadges(state, data) {
  state.unlockedBadges = data
}

export function cleanErrors(state) {
  state.error = false
  state.errorMessage = ''
}

export function error(state, error) {
  console.log("errorcatch", error)
  state.error = true
  state.errorMessage = error
}